import React from "react";

const OrdersLoadingSimple = () => {
  return (
    <div className="space-y-3">
      {Array.from({ length: 5 }).map((_, index) => (
        <div
          key={index}
          className="border-border bg-card animate-pulse rounded-lg border p-4"
        >
          {/* Header Row */}
          <div className="mb-2 flex items-start justify-between">
            {/* Order ID */}
            <div className="flex-1">
              <div className="bg-muted h-6 w-32 rounded"></div>
            </div>

            {/* Price and Date */}
            <div className="text-right">
              <div className="bg-muted mb-1 h-6 w-16 rounded"></div>
              <div className="bg-muted h-4 w-20 rounded"></div>
            </div>
          </div>

          {/* Items Description */}
          <div className="bg-muted h-4 w-3/4 rounded"></div>
        </div>
      ))}
    </div>
  );
};

export default OrdersLoadingSimple;
